module.exports = __webpack_public_path__ + "img/pruebas.cfd1dd04.jpg";